import { Heading, Image } from '@modusign/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import LoadingStatus from '@libs/loading-status';

import requestSigningImage from '@app/assets/modal/start-modal/image-request-signing.png';
import StartContractConfirmModal from '@app/components/Modal/StartContractConfirmModal';
import { contractLinkCreateSetLabels } from '@app/features/contractLink/contractLinkCreate';
import { ContractLinkCreateLayoutLocationState } from '@app/features/contractLink/contractLinkCreate/components/ContractLinkCreateLayout';
import ContractLinkCreationSource from '@app/features/contractLink/contractLinkCreate/types/ContractLinkCreationSource';
import useGetLabelListByIds from '@app/features/label/hooks/useGetLabelListByIds';
import { modalClose } from '@app/store/modal/actions';
import { getUserAuthorityLoadingStatus } from '@app/store/user/authority/selectors';
import { getEmail, getName } from '@app/store/user/user/selectors';

interface ContractLinkStartConfirmModalProps {
  source?: ContractLinkCreationSource;
}

function ContractLinkStartConfirmModal({ source }: ContractLinkStartConfirmModalProps) {
  const dispatch = useDispatch();
  const history = useHistory<ContractLinkCreateLayoutLocationState>();

  const { labels: selectedLabels } = useGetLabelListByIds({
    labelIds: source?.labelIds || [],
  });

  const userAuthorityLoadingStatus = useSelector(getUserAuthorityLoadingStatus);
  const userEmail = useSelector(getEmail) as string;
  const userName = useSelector(getName) as string;

  const isLoading = userAuthorityLoadingStatus === LoadingStatus.PENDING;

  const handleModalClose = () => {
    dispatch(modalClose());
  };

  const onStartContract = () => {
    dispatch(modalClose());
    dispatch(contractLinkCreateSetLabels(selectedLabels));
    history.push('/link/create/position', { source });
  };

  return (
    <StartContractConfirmModal
      checkList={[
        '위 이름과 이메일로 링크를 만듭니다.',
        '링크를 만든 후 문서 수정은 불가능합니다.',
        '링크 접속한 서명자는 문서 조회와 서명이 가능합니다.',
      ]}
      confirmButtonLabel="확인하고 시작하기"
      isLoading={isLoading}
      titleContent={
        <>
          <Image alt="" height="133" src={requestSigningImage} width="243" />
          <Heading className="space-4x">링크서명 시작하기</Heading>
        </>
      }
      userEmail={userEmail}
      userName={userName}
      onModalClose={handleModalClose}
      onStartContract={onStartContract}
    />
  );
}

export default ContractLinkStartConfirmModal;
